import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import http from '@/services/http';
import type { PlaylistTrackRow, TrackVotesContext } from '@/composables/api/usePlaylistSwitchingApi';

/**
 * Generated (zp) playlists — the daily playlists players report as
 * `<28 digits>--<name>.txt` filenames. They live in per-zone shard tables, so
 * every lookup is scoped by location zone.
 */

export interface GeneratedPlaylistTracksResponse {
    list: {
        generated_playlist_id: number;
        location_zone_id: number;
        file_name: string;
        play_date_time: string | null;
        votes_context?: TrackVotesContext | null;
    };
    data: PlaylistTrackRow[];
}

/** Resolved tracks in playlist order (duplicate plays preserved), shaped for TrackCard. */
export function useGeneratedPlaylistTracks(
    locationZoneId: MaybeRefOrGetter<number | null | undefined>,
    generatedPlaylistId: MaybeRefOrGetter<number | null | undefined>
) {
    return useQuery({
        queryKey: computed(() => [
            'generatedPlaylistTracks',
            toValue(locationZoneId) ?? null,
            toValue(generatedPlaylistId) ?? null,
        ]),
        enabled: computed(() => Boolean(toValue(locationZoneId) && toValue(generatedPlaylistId))),
        queryFn: () =>
            http
                .get<GeneratedPlaylistTracksResponse>(
                    `/api/playlists/generated/${toValue(locationZoneId)}/${toValue(generatedPlaylistId)}/tracks`
                )
                .then((response) => response.data),
    });
}
